import { Model, ModelRecord, IModel } from '@common/models/Model';
import { IProactivePrescriptionVeterinarianRuleItemModel } from '@common/models/ProactivePrescriptionVeterinarianRuleItemModel';

export interface IProactivePrescriptionVeterinarianRuleModel extends IModel {
  proactivePrescriptionVeterinarianRuleId: number;
  proactivePrescriptionRuleId: number;
  veterinarianId: number;
  proactivePrescriptionVeterinarianRuleItems: IProactivePrescriptionVeterinarianRuleItemModel[];
}

export class ProactivePrescriptionVeterinarianRuleModel
  extends Model
  implements ModelRecord<IProactivePrescriptionVeterinarianRuleModel>
{
  proactivePrescriptionVeterinarianRuleId: number;
  proactivePrescriptionRuleId: number;
  veterinarianId: number;
  proactivePrescriptionVeterinarianRuleItems: IProactivePrescriptionVeterinarianRuleItemModel[] =
    [];

  constructor(params?: Partial<IProactivePrescriptionVeterinarianRuleModel>) {
    super(params);
    this.proactivePrescriptionVeterinarianRuleId =
      params?.proactivePrescriptionVeterinarianRuleId || 0;
    this.proactivePrescriptionRuleId = params?.proactivePrescriptionRuleId || 0;
    this.veterinarianId = params?.veterinarianId || 0;
    this.proactivePrescriptionVeterinarianRuleItems =
      params?.proactivePrescriptionVeterinarianRuleItems || [];
  }
}
